import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateBranchesStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { BranchApprovalStatusEnum } from '~utils/enums';

export default function* watchUpdateBranchStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateBranchesStatusAttempt', handleUpdateBranchStatus, api);
}

function* handleUpdateBranchStatus(api: ApprovalGateway, data: PayloadAction<TUpdateBranchesStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateBranchStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateBranchesStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === BranchApprovalStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveBranchSuccess
            : status === BranchApprovalStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectBranchSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateBranchesStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingBranchesListingAttempt());
        yield put(combinedActions.approvalUpdateBranchesStatusSuccess());

        toast.success(successMessage);
    }
}
